import { useQueryClient } from '@tanstack/react-query'
import { usePutProvidersUserIdLicensesLicenseId, getGetProvidersUserIdQueryKey } from '@/api/generated/doctor/doctor'
import { formValuesToRequestBody } from '../license-form/transformLicense'
import type { LicenseFormValues } from '../license-form/LicenseFormSchema'

export function useEditLicense(userId: string, licenseId: string) {
  const queryClient = useQueryClient()
  const { mutateAsync: orvalMutateAsync, isPending } = usePutProvidersUserIdLicensesLicenseId()

  async function mutateAsync(values: LicenseFormValues) {
    const data = formValuesToRequestBody(values)
    await orvalMutateAsync({ userId, licenseId, data })

    const queryKey = getGetProvidersUserIdQueryKey(userId)
    queryClient.invalidateQueries({ queryKey })
  }

  return { mutateAsync, isPending }
}
